import React, { useEffect } from "react";
import FurnitureThreeScene from "./FurnitureThreeScene";

//
// NEW
import dataIndustrial from "./dataIndustrial.json";

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
//
//
const FurnitureGrid = ({ setSelectedImgFurniture }) => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //new
  const imgCardIndustrial = dataIndustrial;
  //
  //

  // console.log(imageCards);

  /*
  
  
  
  
  
  
  */

  return (
    <>
      <section id="furniture">
        <div className="furniture___wrapper">
          {/* ------------- */} {/* ----------- */}
          {/* 
          



          
          
          
          */}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                Industrial
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> mid century modern</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>
          {/* ------------- */} {/* ----------- */}
          {/* 
          



          
          
          
          */}
          <div id="furniture___3dScene">
            <div className="furniture__3dScene__Wrapper">
              {/* --------- */}
              <div className="chair__threejsSection">
                <div className="chairBox_three_wrapper">
                  <div className="circlePlay">
                    <h1>Click and Drag</h1>
                    <h2>To Rotate and Zoom</h2>
                  </div>
                  <FurnitureThreeScene />
                </div>
              </div>
            </div>
          </div>
          {/* ------------- */} {/* ----------- */}
          {/* 
          



          
          
          
          */}
          <div className="furniture__descript__row">
            <div className="furniture__descript__row__wrapper">
              <div className="furniture__descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-down">
                  PREFACE
                </h1>
                <h2>Above:</h2>

                <p>Product visualization build with</p>
                <p> Three.js (WebGL Based) and Blender</p>
                <br></br>
                <p>Art Direction</p>
                <p> Modeling - Blender</p>
                <p> Texturing - Threejs</p>
                <p> Lighting - Threejs</p>
                <p>Rendering - Threejs</p>
              </div>
              <div className="furniture__descript__row_article">
                <h1>
                  Ever since I moved to Berlin, I have been fascinated with the
                  Bauhaus movement. My interest was cemented when I learned of
                  the different values, ethics and backgrounds it represented,
                  and represents to this day. After further researching the
                  topic,
                  <span>
                    I realized that my aesthetics aligned with the Mid Century
                    Movement,
                  </span>{" "}
                  that was created when a great number of the teachers of the
                  Bauhaus School fled Germany during the Second World War. Known
                  throughout design history for it’s minimalism despite the use
                  of luxury goods, such as wood, the Mid-Century Movement gave
                  me the outlet I needed to expand my imagination in interior
                  design.
                </h1>
              </div>
            </div>
          </div>
          {/* --------------- */}
          {/* --------------- */}
          <div id="lg__Images__furniture">
            <div className="lg__Images__furniture__wrapper">
              <div className="lg__Images__furniture__container1">
                <div className="img__card">
                  {imgCardIndustrial
                    .filter(
                      (itemCardIndustrial) =>
                        itemCardIndustrial.title1 === "ImgEnv1"
                    )
                    .map((itemCardIndustrial) => (
                      <div key={itemCardIndustrial.id}>
                        <img
                          className="img-box-Misc"
                          src={itemCardIndustrial.img1}
                          alt="img city mono preview"
                        />
                      </div>
                    ))}
                </div>

                {/* ------------- */}
              </div>
              <div className="lg__Images__furniture__container2">
                <div className="img__card">
                  {imgCardIndustrial
                    .filter(
                      (itemCardIndustrial) =>
                        itemCardIndustrial.title1 === "ImgEnv2"
                    )
                    .map((itemCardIndustrial) => (
                      <div key={itemCardIndustrial.id}>
                        <img
                          className="img-box-Misc"
                          src={itemCardIndustrial.img1}
                          alt="img city mono preview"
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          {/* ----- */}
          <div className="furniture__descript__row">
            <div className="furniture__descript__row__wrapper">
              <div className="furniture__descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  Unreal places
                </h1>
                <h2>Above &#x26; Below</h2>
                {/* <h3>The Simurgh Mount </h3> */}
                <p>SOFTWARE USED:</p>
                <p>Blender &#x26; Photoshop</p>
                <br />
                <p>Art Direction</p>
                <p> Modeling - Blender</p>
                <p> Texturing - Blender</p>
                <p> Lighting - Blender</p>
                <p>Rendering - Blender</p>
              </div>
              <div className="furniture__descript__row_article">
                <h1>
                  {" "}
                  This is the reason I decided to develop my skills in 3D design
                  to give form to, and adapt my ideas in a way I never before
                  thought available to me. I thoroughly enjoy my work in the
                  area, and invite you to browse through a{" "}
                  <span className="underline_border">
                    selection of Industrial designs I designed as a tribute to
                    both the Bauhaus, and the Mid-century Movement.
                  </span>{" "}
                  In the images Above and Below you can see a scene I designed
                  in Blender, where I aspired to create a perfect blend between
                  Bauhaus, Mid-Century and post-modern interior design.
                </h1>
              </div>
            </div>
          </div>
          {/* --------------- */}
          {/* --------------- */}
          <div id="galleryFurniture___modal">
            <div className="galleryFurniture___modal__Wrapper">
              {/* ------ */}
              <div className="galleryFurniture__modal__container">
                {imgCardIndustrial &&
                  imgCardIndustrial.map((imgItemFurniture) => (
                    <div
                      className="galleryFurniture__modal___card"
                      key={imgItemFurniture.id}
                      onClick={() =>
                        setSelectedImgFurniture(imgItemFurniture.img1Furniture)
                      }
                    >
                      <div className="img_box">
                        {imgItemFurniture.img1Furniture ? (
                          <motion.img
                            data-aos-duration="1000"
                            data-aos="fade-left"
                            whileHover={{ scale: 1.2 }}
                            onHoverStart={(eImg) => {}}
                            onHoverEnd={(eImg) => {}}
                            src={imgItemFurniture.img1Furniture}
                            alt={imgItemFurniture.alt}
                          />
                        ) : (
                          ""
                        )}
                      </div>

                      <p>
                        {imgItemFurniture.text}
                        <span>{imgItemFurniture.text2} </span>
                      </p>
                    </div>
                  ))}
                {/* ------------- */}
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          
          
        */}
        </div>
      </section>
    </>
  );
};

export default FurnitureGrid;
